// extracted by mini-css-extract-plugin
module.exports = {"Preview":"Preview_Preview__1G0SZ","file":"Preview_file__3CtMS","selected":"Preview_selected__7p3JT","name":"Preview_name__2Gd7E"};